import React from "react";
import { Button, Slot } from "./PillButton.styles";
import type { PillButtonProps } from "./PillButton.types";

/**
 * A pill-shaped text button with optional leading icon and trailing caret.
 * Stateless. A button with aria-disabled stays focusable (for a tooltip) and ignores clicks.
 */
export const PillButton = React.forwardRef<HTMLButtonElement, PillButtonProps>(
  (
    { children, variant = "outline", size = 28, leadingIcon, trailingCaret, type = "button", onClick, ...rest },
    ref,
  ) => {
    const ariaDisabled = rest["aria-disabled"] === true || rest["aria-disabled"] === "true";
    return (
      <Button
        {...rest}
        ref={ref}
        type={type}
        $variant={variant}
        $size={size}
        onClick={ariaDisabled ? undefined : onClick}
      >
        {leadingIcon ? <Slot aria-hidden>{leadingIcon}</Slot> : null}
        {children}
        {trailingCaret ? <Slot aria-hidden>{trailingCaret}</Slot> : null}
      </Button>
    );
  },
);
PillButton.displayName = "PillButton";

export default PillButton;
